




















import { useCategories, categoryGetters, useCurrentComponent } from '@aspenware-library/composables'
import { Category } from '@aspenware-library/types'
import { computed, defineComponent } from '@vue/composition-api'
import { mapGetters } from 'vuex'

export default defineComponent({
  name: 'ResortOsCategoryTabs',
  props: {
    disableCategoryTabs: {
      type: Boolean,
    }
  },
  setup() {
    const { categories } = useCategories()

    function categoryUrl(category: Category) {
      return categoryGetters.getCategoryLink({ category })
    }

    function isLegacyCategory(category: Category) {
      return category.UseLegacy
    }

    const subCategories = computed(() => {
      const initialSubCategories = categories.value.find(cat => cat.SeName === useCurrentComponent()?.$store.getters['products/selectedCategoryPath'])?.SubCategories;
      if (!Array.isArray(initialSubCategories)) {
        return []
      }

      // Ensure we do not show hidden subcategories
      return initialSubCategories.filter(subCategory => subCategory.Hidden !== true)
    })

    return {
      categoryUrl,
      isLegacyCategory,
      subCategories,
    }
  },
  computed: {
    ...mapGetters({
      currentCategory: 'products/selectedCategoryPath',
      selectedSubCategoryId: 'products/selectedSubCategoryId',
    })
  }
})
